import { profileService } from 'src/services/profile.service';
import { utilityService } from 'src/services/utility.service';

export function authHeader() {
	const token = profileService.token;
	if (token) {
		return {
			Authorization: `Bearer ${token}`,
			isEndUser: utilityService.isEndUserBrowsing(),
		};
	}
	return {
		isEndUser: utilityService.isEndUserBrowsing(),
	};
}
